const programmeData = {
    UG: {
      courses: {
        "B.Tech/B.E.": [
          "Civil Engineering (CE)",
          "Computer Science and Engineering (CSE)",
          "Working Professional (CSE)",
          "Working Professional (ME)",
          "Working Professional (EE)",
          "Electronics and Communication Engineering (ECE)",
          "Mechanical Engineering (ME)",
          "Electrical Engineering (EE)",
          "Applied Electronics and Instrumentation",
          "Information Technology"
        ],
        "BCA": [],
        "B.Pharm (Guwahati & Tezpur Campus)": [],
        "B.Pharm Practice": [],
        "B.Sc": [
          "Physics",
          "Chemistry",
          "Mathematics",
          "Zoology",
          "Botany",
          "Psychology",
          "Fire and Safety",
          "Hospitality and Hotel Management",
          "Agriculture (Honours)"
        ],
        "B.A.": [
          "Sociology",
          "Psychology",
          "English",
          "Political Science",
          "History",
          "Education",
          "Journalism and Mass Communication",
          "Economics"
        ],
        "BBA": [],
        "BSW": [],
        "BMLT": [],
        "B.COM": [],
        "B.A. LL.B.": []
      }
    },
    PG: {
      courses: {
        "M.Tech/M.E.": [
          "Computer Science and Engineering (CSE)",
          "Working Professional (CSE)",
          "Working Professional (Civil Engineering)",
          "VLSI Design and Embedded Systems",
          "Structural Engineering (SE)",
          "Thermal & Fluid Engineering (TFE)"
        ],
        "MCA": [],
        "MBA": [],
        "M.Pharm": [
          "Pharmaceutics",
          "Pharmacology",
          "Pharmaceutical Chemistry",
          "Pharmacognosy"
        ],
        "M.Sc": [
          "Computer Science with Specialization in AI/ Data Science / Cyber Security",
          "Physics",
          "Chemistry",
          "Mathematics",
          "Zoology",
          "Psychology",
          "Botany",
          "Economics"
        ],
        "M.A.": [
          "Sociology",
          "Psychology",
          "English",
          "Political Science",
          "Economics",
          "Education",
          "Journalism and Mass Communication",
          "History"
        ],
        "MSW": [],
        "M.Com": [],
        "MMLT": [],
        "MPT": [],
        "LLM": []
      }
    },
    PhD: {
      courses: {
        "Ph.D. in English": [],
        "Ph.D. in Comparative Literature (Multidisciplinary)": [],
        "Ph.D. in Economics": [],
        "Ph.D. in Gender Studies (Multidisciplinary)": [],
        "Ph.D. in Political Science": [],
        "Ph.D. in Sociology": [],
        "Ph.D. in Social Work": [],
        "Ph.D. in Botany": [],
        "Ph.D. in Zoology": [],
        "Ph.D. in Civil Engineering": [],
        "Ph.D. in Mechanical Engineering": [],
        "Ph.D. in Electrical Engineering": [],
        "Ph.D. in Electronics & Communication Engineering": [],
        "Ph.D. in Computer Science & Engineering": [],
        "Ph.D. in Management": [],
        "Ph.D. in Pharmaceutical Sciences (Guwahati & Tezpur Campus)": [],
        "Ph.D. in Physics": [],
        "Ph.D. in Chemistry": [],
        "Ph.D. in Mathematics": [],
        "Ph.D. in Commerce": [],
        "Ph.D. in Health Technology & Policy (Multidisciplinary)": [],
        "Ph.D. in Medical Laboratory Technology": [],
        "Ph.D. in Psychology": [],
        "Ph.D. in History": [],
        "Ph.D. in Education": [],
        "Ph.D. in Journalism and Mass Communication": [],
        "Ph.D. in Physiotherapy": [],
        "Ph.D. in Law": []
      }
    },
    Diploma: {
      courses: {
        "D.Pharm (Guwahati & Tezpur Campus)": []
      }
    }
  };
  
  export default programmeData;
  